import { render, staticRenderFns } from "./SecTitleItem.vue?vue&type=template&id=30d3eab4&scoped=true&"
import script from "./SecTitleItem.vue?vue&type=script&lang=js&"
export * from "./SecTitleItem.vue?vue&type=script&lang=js&"
import style0 from "./SecTitleItem.vue?vue&type=style&index=0&id=30d3eab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3eab4",
  null
  
)

export default component.exports